exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".jzq-logo[data-v-176a1cfc],.jzq-return[data-v-176a1cfc]{height:60px}.jzq-logo[data-v-176a1cfc]{text-align:right}.jzq-logo img[data-v-176a1cfc]{margin:13px}.jzq-return ul[data-v-176a1cfc]{padding:0;margin:0;height:100%}.jzq-return ul li[data-v-176a1cfc]{display:inline-block;height:100%;line-height:60px}.jzq-return ul li a[data-v-176a1cfc]{color:#f0f0f0;padding:0 15px}.jzq-return ul li a[data-v-176a1cfc]:hover{color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":0,"alias":{"/assets":"/opt/nodeapps/svndata/jzq-web/assets","/static":"/opt/nodeapps/svndata/jzq-web/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-176a1cfc","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./layouts/auth.vue
// module id = H5wT
// module chunks = 204